import React, {useState, useEffect, useRef} from "react";
import {useSelector} from "react-redux";
import {getMonthRange, monthNames} from "../Utility";
import Stack from "../ui/Stack";

const MonthFilter = ({onMonthChange, yearRange = 5}) => {
    const {dateInfo} = useSelector((state) => state.utility);
    const {monthRange, monthFilterStatus} = useSelector((state) => state.financial);
    const onMonthChangeRef = useRef(onMonthChange);

    // Default values if dateInfo is not yet available
    const defaultDatetime = dateInfo?.datetime || new Date().toISOString();
    const defaultUtcOffset = dateInfo?.utc_offset || "+05:30";

    const currentYear = new Date(defaultDatetime).getFullYear();

    // If monthFilterStatus is true, use monthRange from Redux
    const initialYear = monthFilterStatus && monthRange
        ? new Date(monthRange.start).getFullYear()
        : currentYear;

    const initialMonth = monthFilterStatus && monthRange
        ? new Date(monthRange.end).getMonth()
        : new Date(defaultDatetime).getMonth();

    const [selectedYear, setSelectedYear] = useState(initialYear);
    const [selectedMonth, setSelectedMonth] = useState(initialMonth);

    // Skip first render flag
    const isFirstRender = useRef(true);

    // Generate years for dropdown (current year ± yearRange)
    const years = Array.from(
        {length: yearRange * 2 + 1},
        (_, i) => currentYear - yearRange + i
    );

    const handleMonthChange = (e) => setSelectedMonth(+e.target.value);
    const handleYearChange = (e) => setSelectedYear(+e.target.value);

    // Always keep the latest callback
    useEffect(() => {
        onMonthChangeRef.current = onMonthChange;
    }, [onMonthChange]);

    // Trigger callback only when user changes month/year (skip initial mount)
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const range = getMonthRange(selectedYear, selectedMonth, defaultUtcOffset);
        onMonthChangeRef.current && onMonthChangeRef.current(range);
    }, [selectedMonth, selectedYear, defaultUtcOffset]);

    if (!dateInfo) return null;

    return (
        <Stack className="gap-2 align-items-center">
            {/* Year dropdown */}
            <select
                value={selectedYear}
                className="form-select form-select-md"
                onChange={handleYearChange}
            >
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>

            {/* Month dropdown */}
            <select
                value={selectedMonth}
                className="form-select form-select-md"
                style={{minWidth: "max-content"}}
                onChange={handleMonthChange}
            >
                {monthNames.map((name, index) => (
                    <option key={index} value={index}>
                        {name}
                    </option>
                ))}
            </select>
        </Stack>
    );
};

export default MonthFilter;
